import React, { PropTypes } from 'react'
import { connect } from 'react-redux'
import { Form } from 'react-redux-form/immutable'
import Panel from 'react-bootstrap/lib/Panel'
import Table from 'react-bootstrap/lib/Table'

import { makeGetFilteredOfferings } from 'containers/Enrolment/selectors'

import ListOfferingItem from './list-offering-item'

const ListOfferings  = ({ __offeringState, handleClose, onAdd }) => (
  <Form model="offeringState" className="offerings-box">
    <Panel header="Subject Offerings">
      <div className="text-right">
        <button type="button" onClick={handleClose} className="btn btn-default">Close</button>{' '}
        <button type="button" onClick={onAdd} className="btn btn-info">Request Add Subjects</button>
      </div>
      <hr />
      <Table condensed hover>
        <thead>
          <tr>
            <th width="1%">{' '}</th>
            <th width="10%">Subject Code</th>
            <th width="5%">Section</th>
            <th>Subject Description</th>
            <th width="18%">Schedule</th>
            <th width="5%" className="text-right">Units</th>
            <th width="15%">Instructor</th>
            <th width="5%">Slots</th>
          </tr>
        </thead>
        <tbody>
          {__offeringState.map((item, k) => (
            <ListOfferingItem item={item} key={k} k={item.get('k')} />
          ))}
        </tbody>
      </Table>
      <hr />
      <div className="row">
        <div className="col-xs-4">
          <div className="legend">
            <h4>Legend: </h4>
            <Table condensed>
              <tbody>
                <tr className="warning">
                  <td>Repeat subject</td>
                </tr>
                <tr className="success">
                  <td>Recommended subject</td>
                </tr>
                <tr className="active">
                  <td>Offered but PreRequisite not met.</td>
                </tr>
              </tbody>
            </Table>
          </div>
        </div>
        <div className="col-xs-4 text-right">
          <small><em>*This facility does not check for schedule conflicts yet. Please check your schedule manually for the time being. Thank you.</em></small>
        </div>
      </div>
    </Panel>
  </Form>
)

ListOfferings.propTypes = {
  __offeringState: PropTypes.object,
}

function mapStateToProps(state) {
  const getFilteredOfferings = makeGetFilteredOfferings()
  return {
    __offeringState: getFilteredOfferings(state),
  }
}

export default connect(mapStateToProps)(ListOfferings)



// WEBPACK FOOTER //
// ./src/containers/Enrolment/AddWithdraw/list-offerings.js